import React from 'react';
import type { InvoiceStatus } from '../../types/invoice';

/** Grøn = betalt, gul = afventer betaling, rød = overskredet. */
const styles: Record<InvoiceStatus | 'Forfalden', string> = {
  Kladde: 'border-line bg-canvas-deep text-ink-soft',
  'Klar til afsendelse': 'border-accent/40 bg-accent/10 text-accent-deep',
  Sendt: 'border-status-warn/40 bg-status-warn/10 text-status-warn',
  Betalt: 'border-status-ok/40 bg-status-ok/10 text-status-ok',
  Annulleret: 'border-line bg-transparent text-ink-muted',
  Forfalden: 'border-danger/40 bg-danger/10 text-danger'
};
export function InvoiceStatusBadge({
  status
}: {
  status: InvoiceStatus | 'Forfalden';
}) {
  return <span className={`inline-flex shrink-0 items-center whitespace-nowrap rounded-md border px-2.5 py-1 text-xs font-medium ${styles[status]}`} data-id="element-150" data-mp="2w2ekg8cfoqqp">
      {status}
    </span>;
}